import { error, finish } from 'src/modules/market-templates/actions/market-template-creation';
// import api from '../../../api';

export function request(dispatch, { sportId, market }) {
    const { eventTemplateId, id: templateId, displayOrder, marketSubtype, name } = market;

    $appState.sdkStaff.createMarketTemplate({
        requestBody: {
            displayOrder,
            eventTemplateId,
            marketSubtype,
            name,
            sportId,
            templateId
        }
    }).then(data => dispatch(finish(sportId, data)));

    // api.post(`/sports/${sportId}/event-templates/${eventTemplateId}/market-templates/${templateId}/create`, market).then(
    //     marketTemplate => {
    //         dispatch(finish(sportId, marketTemplate));
    //     },
    //     errors => dispatch(error(sportId, errors))
    // );
}
